import React, { useEffect, useState } from 'react';
import Select, { Ioption } from 'components/Material/Select';

import { option2Trans } from 'main_func';
import { Grid } from '@material-ui/core';
import { VcGrid } from 'components/Grid';
import Input from 'components/Material/Input';
import { Iobject } from 'main_type';

interface IProp {
  index: string;
  value: {
    mawbVal: string;
    hawbVal: string;
    dutyNoVal: string;
    qryInputType: string;
  };
  fatherUpdateData: (x: Iobject) => void;
}

const QryInput = (props: IProp): JSX.Element => {
  const { index, fatherUpdateData, value } = props;
  const [qryInputType, setQryInputType] = useState(value.qryInputType || '1');
  const [mawbVal, setMawbVal] = useState(value.mawbVal);
  const [hawbVal, setHawbVal] = useState(value.hawbVal);
  const [dutyNoVal, setDutyNoVal] = useState(value.dutyNoVal);

  const [option, setOption] = useState<Ioption[]>([]);
  const [transOptions] = option2Trans(option);

  const updateData = async (
    e:
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    switch (e.target.name) {
      case 'qryInputType':
        setQryInputType(e.target.value);
        break;
      case 'mawbVal':
        setMawbVal(e.target.value);
        break;
      case 'hawbVal':
        setHawbVal(e.target.value);
        break;
      case 'dutyNoVal':
        setDutyNoVal(e.target.value);
        break;

      default:
        break;
    }
  };
  const init = () => {
    setOption([
      { value: '1', label: '主分號' },
      { value: '2', label: '稅單號碼' },
    ]);
  };

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    const data: Iobject = {};
    const mawbName = `mawb${index}`;
    const hawbName = `hawb${index}`;
    const dutyNoName = `dutyNo${index}`;
    const qryInputTypeName = `qryInputType${index}`;
    data[mawbName] = mawbVal;
    data[hawbName] = hawbVal;
    data[dutyNoName] = dutyNoVal;
    data[qryInputTypeName] = qryInputType;
    fatherUpdateData(data);
  }, [qryInputType, mawbVal, hawbVal, dutyNoVal]);

  return (
    <>
      <Grid container>
        <VcGrid item xs={12} sm={2} />
        <VcGrid item xs={12} sm={3} style={{ paddingRight: '0.5em' }}>
          <Select
            value={qryInputType}
            name="qryInputType"
            onChange={async (e) => {
              updateData(e);
            }}
            options={transOptions}
          />
        </VcGrid>
        {qryInputType === '1' ? (
          <>
            <VcGrid item xs={12} sm={3} style={{ paddingRight: '0.5em' }}>
              <Input
                placeholder="主號"
                value={mawbVal}
                name="mawbVal"
                required={hawbVal.length > 0}
                onChange={(e) => {
                  updateData(e);
                }}
              />
            </VcGrid>
            <VcGrid item xs={12} sm={3}>
              <Input
                placeholder="分號"
                value={hawbVal}
                name="hawbVal"
                required={mawbVal.length > 0}
                onChange={(e) => {
                  updateData(e);
                }}
              />
            </VcGrid>
          </>
        ) : (
          <VcGrid item xs={12} sm={3} style={{ paddingRight: '0.5em' }}>
            <Input
              placeholder="稅單號碼"
              value={dutyNoVal}
              name="dutyNoVal"
              onChange={(e) => {
                updateData(e);
              }}
            />
          </VcGrid>
        )}
      </Grid>
    </>
  );
};
export default QryInput;
